import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export const keys = createQueryKeySet<ClubListQueryParams>('clubs');

export type ClubListQueryParams = Parameters<typeof SSF.api.clubsList>[0];
export type ClubListOrdering = Exclude<ClubListQueryParams, undefined>['ordering'];

export function useClubListQuery(params?: ClubListQueryParams, enabled = true) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.clubsList(params);
      return data;
    },
    queryKey: keys.list(params),
    enabled,
  });
}

export function useClubQuery(id: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.clubsRetrieve(id);
      return data;
    },
    queryKey: keys.detail(id),
  });
}
